<!--
 * @Date: 2025-06-20 10:38:02
 * @LastEditors: 'lidianbin' 'lidianbin@coocaa.com'
 * @LastEditTime: 2025-06-20 10:55:02
 * @FilePath: \ccms\packages\cms-components\lib\components\advanceImgTxtFour\ImageWrapper.vue
-->
<template>
  <div
    class="image-wrapper"
  >
    <video
      v-if="cardData.videoUrl"
      class="video-wrapper"
      :src="cardData.videoUrl"
      :controls="false"
      autoplay
      loop
      muted
      :poster="cardData.imageUrl"
      :style="{
        width: '100%',
        height: '100%',
        borderRadius: imageConfig.borderRadius ? arrToPx(imageConfig.borderRadius) : '',
        'object-fit': 'cover'
      }"
    ></video>
    <el-image
      v-else
      class="image-wrapper--full-cover"
      :src="cardData.imageUrl"
      :fit="imageConfig.fit"
      :style="{
        width: '100%',
        height: '100%',
        borderRadius: imageConfig.borderRadius ? arrToPx(imageConfig.borderRadius) : ''
      }"
    ></el-image>
  </div>
</template>

<script>
import { arrToPx } from '../../utils/index'
export default {
  components: {},
  props: ['cardData', 'imageConfig'],
  data () {
    return {}
  },
  computed: {},
  methods: {
    arrToPx
  },
  created() {
    //
  }
}
</script>

<style lang="stylus" scoped>
</style>
